import Typography from "@/design-system/Typography";
import Button from "@/design-system/button";
import { languageSelector } from "@/src/contexts";
import { formatBytes, urlFormat } from "@Components/Modules/Helpers";
import { GDPRFileDownload } from "@Routes/FileDownloadLinks";
import * as stylex from "@stylexjs/stylex";

import { GDPRFilesResources } from "./GDPRFiles.Resources";
import { GDPRFilesResourcesEn } from "./GDPRFiles.Resources.EN";

export interface IGDPRFiles {
    files: IGDPRFile[];
}

export interface IGDPRFile {
    id: string;
    fileSize: number;
    lastModifiedDate: string;
    fileType: GDPRFileType;
}

export enum GDPRFileType {
    PDF = 0,
    JSON = 1,
}

export default function GDPRFiles(props: IGDPRFiles) {
    const { title, description, downloadButton, fileSize, fileDate } = languageSelector(
        GDPRFilesResources,
        GDPRFilesResourcesEn,
    );

    const buildFileSection = (file: IGDPRFile) => (
        <div key={file.id}>
            <Button
                variant="blue"
                as="a"
                size="M"
                target="_blank"
                href={urlFormat(
                    GDPRFileDownload,
                    {
                        fileId: file.id,
                    },
                    true,
                )}
                styleX={styles.button}
            >
                {downloadButton.replace("{0}", GDPRFileType[file.fileType])}
            </Button>
            <div>{fileSize.replace("{0}", formatBytes(file.fileSize))}</div>
            <div>{fileDate.replace("{0}", file.lastModifiedDate.split(",")[0])}</div>
        </div>
    );

    return props.files && props.files.length > 0 ? (
        <div>
            <Typography textElement="h1">{title}</Typography>
            <div>{description}</div>
            {props.files && props.files.map(buildFileSection)}
        </div>
    ) : null;
}

const styles = stylex.create({
    button: {
        marginBottom: "15px",
        marginTop: "40px",
    },
});
